import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { apiError } from "@/lib/api";
import BrandMark from "@/components/BrandMark";

export default function Register() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Compte créé");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="register-form">
        <div className="mb-2">
          <BrandMark variant="compact" />
        </div>
        <div>
          <h2 className="text-2xl tracking-tight font-medium">Créer un compte</h2>
          <p className="text-sm text-muted-foreground mt-1">Commencez à prospecter intelligemment.</p>
        </div>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="name" className="text-xs">Nom</Label>
            <Input id="name" required value={name} onChange={(e)=>setName(e.target.value)} className="h-9" data-testid="register-name" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-xs">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="h-9" data-testid="register-email" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-xs">Mot de passe</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="h-9" data-testid="register-password" />
          </div>
        </div>
        <Button type="submit" disabled={loading} className="w-full h-9" data-testid="register-submit">
          {loading ? "Création…" : "Créer mon compte"}
        </Button>
        <div className="text-xs text-muted-foreground text-center">
          Déjà inscrit ? <Link to="/login" className="text-primary hover:underline">Se connecter</Link>
        </div>
      </form>
    </div>
  );
}
